import { Button } from "@libs/zapi-ui/ds/components/button";

type TLeoWelcomeProps = {
  title: string;
  subtitle: string;
  suggestions: string[];
  onPick: (suggestion: string) => void;
  disabled?: boolean;
};

export function LeoWelcome({ title, subtitle, suggestions, onPick, disabled }: TLeoWelcomeProps) {
  return (
    <div data-testid="leo-welcome" className="flex min-h-full flex-1 flex-col gap-5">
      <div className="flex flex-1 flex-col items-center justify-center gap-1.5 text-center">
        <h2 className="typo-h5 text-foreground">{title}</h2>
        <p className="typo-body-sm text-muted-foreground">{subtitle}</p>
      </div>
      <div className="flex flex-col items-start gap-1.5">
        {suggestions.map((suggestion) => (
          <Button
            key={suggestion}
            type="button"
            variant="outline"
            size="sm"
            shape="pill"
            disabled={disabled}
            onClick={() => onPick(suggestion)}
            className="h-auto max-w-full justify-start py-1.5 text-start whitespace-normal text-muted-foreground shadow-none"
          >
            <span className="typo-body-sm">{suggestion}</span>
          </Button>
        ))}
      </div>
    </div>
  );
}
